<div class="chat-history-item">
    <ng-container *ngIf="targetUser; else loading">
        <div class="chat-history-item__avatar">
            <app-user-avatar
                [firstName]="targetUser.firstName"
                [lastName]="targetUser.lastName"
                [picture]="targetUser.pictureReference"
                [size]="'40px'"
            ></app-user-avatar>
        </div>

        <div class="chat-history-item__content">
            <div class="chat-history-item__header">
                <span class="chat-history-item__name"> {{ targetUser.firstName }} {{ targetUser.lastName }} </span>

                <span class="chat-history-item__date" *ngIf="conversation.lastMessageAt">
                    {{ conversation.lastMessageAt | smartDate }}
                </span>
            </div>

            <div class="chat-history-item__bottom">
                <p class="chat-history-item__last-message" [innerHTML]="lastMessage || conversation.lastMessagePreview | nl2br"></p>
                <span class="chat-history-item__badge" *ngIf="notifCount > 0">
                    {{ notifCount > 99 ? '99+' : notifCount }}
                </span>
            </div>
        </div>
    </ng-container>

    <ng-template #loading>
        <div class="chat-history-item__avatar">
            <p-skeleton shape="circle" size="50px"></p-skeleton>
        </div>

        <div class="chat-history-item__content">
            <div class="chat-history-item__header">
                <p-skeleton width="8rem"></p-skeleton>
            </div>

            <div class="chat-history-item__bottom">
                <p class="chat-history-item__last-message">
                    <p-skeleton width="12rem" height="0.9rem"></p-skeleton>
                </p>
            </div>
        </div>
    </ng-template>
</div>
